<template>
  <!-- 自定义表单 -->
  <div class="cmp-form">
    <span v-if="itemData.title">{{itemData.title}}</span>
    <!-- 上传附件 -->
    <el-form-item class="fujian-list" :label="itemData.label" v-if="itemData.type === 'file'" :label-width="itemData.labelWidth">
      <!-- 上传 -->
      <cmp-upload
        :callFun="uploadCallback"
        :fileList="remoteFileList"
        :businessType="`workflow`"
        accept=".rar, .zip, .doc, .docx, .pdf, .jpg, .xls, .xlsx"
        :showName="true"
        :showTip="true"
        :txt="`本地上传`"
        :isPicDiff="true"
        :isDisable="isDisable"
      ></cmp-upload>
    </el-form-item>

    <!-- input -->
    <template v-if="itemData.type === 'input' && !itemData.isHide">
      <el-form-item
        :label="itemData.label"
        :prop="itemData.name"
        :rules="itemData.reg === 'numDecimal' ? rulesObj.numDecimal : (itemData.reg === 'numOne' ? rulesObj.numOne : (itemData.reg === 'numForward' ? rulesObj.numForward : itemData.rules))"
        :label-width="itemData.labelWidth"
      >
        <span v-if="itemData.isAutoFill">{{itemData.text}}</span>
        <el-input v-else
          v-model="form[itemData.name]"
          :placeholder="itemData.placeholder"
          :maxlength="itemData.maxlength||''"
          show-word-limit
          :disabled="isDisable"
          @change="changeInput"
          :class="{'has-limit': !itemData.maxlength}"
          :style="{'width:': '80px'}"
        ></el-input>
      </el-form-item>
    </template>

    <!-- 20220812改版 -->
    <!-- 金额 -->
    <div v-if="itemData.type === 'calc'">
      <el-form-item class="is-required" :label="itemData.label" :prop="itemData.name"  :label-width="itemData.labelWidth">
        <el-input
          v-model="form[itemData.name]"
          :placeholder="itemData.placeholder"
          :disabled="true"
        ></el-input>
      </el-form-item>
    </div>
    <!-- end -->
    
    <!-- 上个版本 start -->
    <!-- 金额 -->
    <!-- <div
      v-if="itemData.type === 'calc'"
      :class="{'hide': form.key === 'QJSQ' 
      && (form.holidayType === '0' || form.holidayType === '3') 
      && itemData.name === 'durationHour'
      }"
    >
      <div
        :class="{'hide': form.key === 'QJSQ'
        && form.holidayType !== '0' && form.holidayType !== '3'
        && itemData.name === 'durationDay'}"
      >
        <el-form-item class="is-required" :label="itemData.label" :prop="itemData.name"  :label-width="itemData.labelWidth">
          <el-input
            v-model="form[itemData.name]"
            :placeholder="itemData.placeholder"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </div>
    </div> -->
    <!-- 上个版本 end -->

    <!-- textarea -->
    <template v-if="itemData.type === 'textarea'">
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
        <el-input
          type="textarea"
          v-model="form[itemData.name]"
          :placeholder="itemData.placeholder"
          :maxlength="itemData.maxlength||200"
          show-word-limit
          @change="changeTextarea"
          :disabled="isDisable"
        ></el-input>
      </el-form-item>
    </template>

    <!-- datepicker -->
    <!-- 普通 -->
    <template v-if="itemData.type === 'date'">
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
        <el-date-picker
          v-model="form[itemData.name]"
          :picker-options="configOptions[itemData.name]"
          type="date"
          value-format="yyyy-MM-dd"
          :placeholder="itemData.placeholder"
          @change="changeTime"
          :disabled="isDisable"
        ></el-date-picker>
      </el-form-item>
    </template>

    <!-- 日期-上午 -->
    <!-- 请假申请：年假、调休假可见 -->
    <div v-if="itemData.type === 'date-AM'">
      <!-- 20220812改版 -->
      <el-form-item :label="itemData.label" :rules="itemData.rules"  :label-width="itemData.labelWidth">
        <el-row :gutter="10" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item :prop="itemData.name[0]" :rules="itemData.rules">
              <el-date-picker
                v-model="form[itemData.name[0]]"
                type="date"
                :value-format="'yyyy-MM-dd'"
                format="yyyy-MM-dd"
                :placeholder="itemData.placeholder"
                :picker-options="configOptions[itemData.name[0]]"
                @change="changeTimeNoon(itemData.name[0])"
                :disabled="isDisable"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :prop="itemData.name[1]">
              <el-select
                v-model="form[itemData.name[1]]"
                :placeholder="itemData.placeholder"
                @change="changeTimeNoon(itemData.name[1])"
                :disabled="isDisable"
              >
                <el-option
                  v-for="item in itemData.options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <!-- end -->

      <!-- 上个版本 start -->
      <!-- <div v-if="form.key === 'QJSQ' && form.holidayType !== '0' && form.holidayType !== '3'"></div>

      <div v-else>
        <el-form-item :label="itemData.label" :rules="itemData.rules"  :label-width="itemData.labelWidth">
          <el-row :gutter="10" type="flex" justify="space-between">
            <el-col :span="12">
              <el-form-item :prop="itemData.name[0]" :rules="itemData.rules">
                <el-date-picker
                  v-model="form[itemData.name[0]]"
                  type="date"
                  :value-format="'yyyy-MM-dd'"
                  format="yyyy-MM-dd"
                  :placeholder="itemData.placeholder"
                  :picker-options="configOptions[itemData.name[0]]"
                  @change="changeTimeNoon(itemData.name[0])"
                  :disabled="isDisable"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :prop="itemData.name[1]">
                <el-select
                  v-model="form[itemData.name[1]]"
                  :placeholder="itemData.placeholder"
                  @change="changeTimeNoon(itemData.name[1])"
                  :disabled="isDisable"
                >
                  <el-option
                    v-for="item in itemData.options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </div> -->
      <!-- 上个版本 end -->
    </div>

    <!-- 20220812改版 -->
    <!-- 日期-小时 -->
    <div v-if="itemData.type === 'date-HH'">
      <el-form-item :label="itemData.label" :label-width="itemData.labelWidth">
        <el-row :gutter="10" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item :prop="itemData.name[0]">
              <el-date-picker
                v-model="form[itemData.name[0]]"
                :picker-options="configOptions[itemData.name]"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="itemData.placeholder"
                @change="changeTimeHour(itemData.name[0])"
                :disabled="isDisable"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :prop="itemData.name[1]">
              <el-select v-model="form[itemData.name[1]]" :placeholder="itemData.placeholder">
                <el-option
                  v-for="item in itemData.options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  @change="changeTimeHour(itemData.name[1])"
                  :disabled="isDisable"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </div>
    <!-- end -->

    <!-- 20220812改版 -->
    <!-- 日期-分钟 -->
    <div v-if="itemData.type === 'date-HM'">
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
        <el-date-picker
          v-model="form[itemData.name]"
          :picker-options="configOptions[itemData.name]"
          :value-format="'yyyy-MM-dd HH:mm'"
          format="yyyy-MM-dd HH:mm"
          type="datetime"
          :placeholder="itemData.placeholder"
          @change="changeTime"
          :disabled="isDisable"
        ></el-date-picker>
      </el-form-item>
    </div>
    <!-- end -->

    <!-- 上个版本 start -->
    <!-- 日期-小时 -->
    <!-- 请假申请：非年假、调休假可见 -->
    <!-- <div
      v-if="itemData.type === 'date-HH'"
      :class="{'hide': form.key === 'QJSQ' && (form.holidayType === '0' || form.holidayType === '3')}"
    >
      <el-form-item :label="itemData.label" :label-width="itemData.labelWidth">
        <el-row :gutter="10" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item :prop="itemData.name[0]">
              <el-date-picker
                v-model="form[itemData.name[0]]"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="itemData.placeholder"
                @change="changeTimeHour(itemData.name[0])"
                :disabled="isDisable"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :prop="itemData.name[1]">
              <el-select v-model="form[itemData.name[1]]" :placeholder="itemData.placeholder">
                <el-option
                  v-for="item in itemData.options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                  @change="changeTimeHour(itemData.name[1])"
                  :disabled="isDisable"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </div> -->
    <!-- 上个版本 end -->

    <!-- 上个版本 start -->
    <!-- 日期-分钟 -->
    <!-- <div v-if="itemData.type === 'date-HM'">
      <div v-if="form.key === 'QJSQ' && (form.holidayType === '0' || form.holidayType === '3')"></div>

      <div v-else>
        <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
          <el-date-picker
            v-model="form[itemData.name]"
            :value-format="'yyyy-MM-dd HH:mm'"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            :placeholder="itemData.placeholder"
            @change="changeTime"
            :disabled="isDisable"
          ></el-date-picker>
        </el-form-item>
      </div>
    </div> -->
    <!-- 上个版本 end -->

    <!-- select -->
    <template v-if="itemData.type === 'select'">
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
        <el-select
          v-model="form[itemData.name]"
          :placeholder="itemData.placeholder"
          @change="changeSelect"
          :disabled="isDisable"
          :multiple="itemData.multiple"
          :filterable="itemData.multiple||itemData.remoteApi&&true"
          :remote="itemData.remoteApi?true:false"
          :remote-method="remoteMethod"
          :loading="itemData.remoteApi?this.selLoading:false"
          clearable
        >
          <el-option
            v-for="item in itemData.options"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </template>

    <!-- radio -->
    <template v-if="itemData.type === 'radio'">
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth">
        <el-radio-group v-model="form[itemData.name]" :disabled="isDisable" @change="changeRadio">
          <el-radio
            :label="item.value"
            v-for="item in itemData.options"
            :key="item.value"
          >{{item.name}}</el-radio>
        </el-radio-group>
      </el-form-item>
    </template>

    <!-- checkbox -->
    <template v-if="itemData.type === 'checkbox'">
      <!-- <span>{{itemData.label}}</span> -->
      <el-form-item :label="itemData.label" :prop="itemData.name" :rules="itemData.rules" :label-width="itemData.labelWidth" v-if="form[itemData.name]">
        <!-- <span v-show="form[itemData.name]">{{itemData.name}}333</span> -->
        <!-- <p>{{itemData.name}}{{form[itemData.name]}}</p> -->
        
        <el-checkbox-group v-model="form[itemData.name]" :disabled="isDisable" @change="changeCheckbox">
          <el-checkbox
            :label="item.value"
            v-for="item in itemData.options"
            :key="item.value"
          >{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </template>
  </div>
</template>

<script>
import { validate } from '@/utils/util'
import cmpUpload from '@cmp/my-upload/index' //上传组件
export default {
  components: { cmpUpload },
  props: {
    showType: {
      type: String,
      default: 'input'
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    configOptions: {
      type: Object,
      default() {
        return {}
      }
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    isDisable: {
      type: Boolean,
      default: false
    },
    remoteFileList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    form(newVal) {
      // console.log(11111111111111, newVal)
      return newVal
    },
    // itemData(newVal) {
    //   // console.log(11111111111111, newVal)
    //   return newVal
    // },
    isDisable(newVal) {
      return newVal
    }
  },
  data() {
    let validateReceiptNumber = (rule, value, callback) => {
      if (!validate(value, 'numDecimal')) {
        return callback(new Error('必须非负数且至多保留两位小数'))
      } else {
        callback()
      }
    }
    let validateNumber = (rule, value, callback) => {
      if (!validate(value, 'numForward')) {
        return callback(new Error('必须为正整数'))
      } else {
        callback()
      }
    }
    let validateNumOne = (rule, value, callback) => {
      if (!validate(value, 'numOne')) {
        return callback(new Error('必须非负数且至多保留一位小数'))
      } else {
        callback()
      }
    }
    return {
      // remoteFileList: [],
      options: [
        {
          value: '1',
          label: '类别1'
        },
        {
          value: '2',
          label: '类别2'
        }
      ],
      rulesObj: {
        numForward: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        numDecimal: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: validateReceiptNumber, trigger: 'blur' }
        ],
        numOne: [
          { required: true, message: '必填', trigger: 'blur' },
          { validator: validateNumOne, trigger: 'blur' }
        ]
      },
      selLoading: false,
      // totalPage: 0
    }
  },
  methods: {
    changeSelect() {
      // 请假类型
      if (this.itemData.name === 'holidayType') {
        this.$emit('changeHolidayType')
      }
    },
    changeInput() {
      // this.$forceUpdate() //解决偶尔input框无法输入进去的问题
      if (this.itemData.ralationship) {
        this.$emit('calcFun', this.itemData.ralationship, this.itemData.name)
      }

      // 刷新审批人
      if(this.itemData.refreshChecker) {
        this.$emit('eventChecker')
      }
    },
    // 选中后另一个输入框禁用
    changeCheckbox() {
      if (this.itemData.ralationDisable) {
        this.$emit('callFunDisable', this.itemData.ralationDisable, this.itemData.name)
      }
    },
    // 选择其他时出现文本框 relationOtherValue: 其他对应的value值  relationOtherName: 其他文本框的字段名
    changeRadio() {
      // console.log(this.itemData.relationOtherValue)
      // console.log(this.itemData.relationOtherShow)
      // console.log(11, this.form[this.itemData.name])
      if (this.form[this.itemData.name] === this.itemData.relationOtherValue) {
        this.$emit('callFunOther', this.itemData.relationOtherName, this.itemData.name, false)
      } else {
        this.$emit('callFunOther', this.itemData.relationOtherName, this.itemData.name, true)
      }
    },
    changeTextarea() {
      // this.$forceUpdate() //解决偶尔input框无法输入进去的问题
    },
    changeTime() {
      // console.log(this.itemData.ralationship)
      // this.$forceUpdate() //解决偶尔input框无法输入进去的问题
      if (this.itemData.ralationship) {
        this.$emit('calcTime', this.itemData.ralationship, this.itemData.name)
      } else {
        // 开始时间和结束时间之间的限制
        if (
          this.itemData.name === 'startTime' ||
          this.itemData.name === 'endTime'
        ) {
          this.$emit('calcTime', '', this.itemData.name)
        }
      }
    },
    changeTimeNoon(name) {
      // this.$forceUpdate() //解决偶尔input框无法输入进去的问题
      if (this.itemData.ralationship) {
        this.$emit('calcTimeNoon', this.itemData.ralationship, name)
      }
    },
    uploadCallback(ids) {
      this.$emit('fujian', ids)
    },
    // 下拉框启用远程搜索
    remoteMethod(query) {
      console.log(this.itemData)
      if(!this.itemData.remoteApi) return

      if(!query) {
        // this.$set(this.itemData, 'options', [])
        return
      }

      this.selLoading = true
      this.$http
        .get(this.itemData.remoteApi, {
          key: query
        })
        .then(res => {
          this.selLoading = false
          if (res.success) {
            let data = res.result
            this.$set(this.itemData, 'options', data)
            // this.$set(this.itemData, 'options', [
            //   {
            //     "name": "藏品1",
            //     "value": "1"
            //   },
            //   {
            //     "name": "藏品2",
            //     "value": "2"
            //   },
            //   {
            //     "name": "藏品3",
            //     "value": "3"
            //   }
            // ])
            // this.totalPage = res.page.totalPage
          } else {
            this.$message.error(res.message)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fujian-list {
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: solid 1px $border;
  border-bottom: solid 1px $border;
}
.el-radio-group {
  .el-radio {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.el-select {
  width: 100%;
}
.el-input.has-limit {
  /deep/ .el-input__inner {
    padding-right: 50px;
  }
}
</style>


